let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("9mi9f")]).then(() => parcelRequire('HJnwX'));